// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3scht","list":"styles_list__2Wjz7"};